import { useAppSelector } from "hooks/reduxHooks";
import { useEffect } from "react";

export const useReadUser = (): any | null => {
  const userStr = useAppSelector((state) => state.user.user);
  return userStr || null;
};

export const useUserInfo = (): any | null => {
  const userStr = useAppSelector((state) => state.user.userInformation);
  return userStr || null;
};

export const useFeatureAllowedFromState = (feature: string): boolean => {
  const userInfo = useReadUser();

  if (
    userInfo &&
    userInfo.feature_list &&
    userInfo.feature_list.length > 0 &&
    userInfo.feature_list.findIndex((f: any) => f.feature_code === feature) > -1
  ) {
    return true;
  }
  return false;
};

export const useIsOldFlow = () => {
  const userInfo = useUserInfo();
  
  if (userInfo && userInfo.is_hr_flow) {
    return false;
  }
  return true;
};

export const useDebugRedux = (sliceName = 'reportSlice') => {
  const state = useAppSelector((state: any) => state[sliceName]);
  
  useEffect(() => {
    console.log(`${sliceName} state updated:`, state);
  }, [state, sliceName]);
};